import { Box, Tooltip, Typography, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { tokens } from '../../../../../global/theme/tokens';

// Stacked bar of one work package: done, open and overdue share 100%.
// Overdue tasks are part of the open ones, so they are cut out of the blue part.
const WorkPackageProgressRow = ({ workPackage }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode, theme.palette.colorTheme);
  const { t } = useTranslation();

  const { title, icon, total, done, open, overdue } = workPackage;

  const share = (value) => (total ? (value / total) * 100 : 0);
  const segments = [
    { label: t('Done'), color: colors.success, value: done },
    { label: t('Open'), color: colors.info, value: Math.max(open - overdue, 0) },
    { label: t('Overdue'), color: colors.error, value: overdue },
  ].map((segment) => ({ ...segment, width: share(segment.value) }));

  return (
    <Box className="flex items-center gap-2 min-w-0">
      {icon?.temporaryUrl ? (
        <img
          src={icon.temporaryUrl}
          alt=""
          className="w-5 h-5 object-contain shrink-0"
        />
      ) : (
        <Box className="w-5 h-5 shrink-0" />
      )}

      <Typography
        fontSize="13px"
        noWrap
        className="w-[110px] sm:w-[160px] shrink-0"
      >
        {title}
      </Typography>

      <Box
        className="flex grow h-[13px] rounded-full overflow-hidden min-w-0"
        sx={{ backgroundColor: colors.bgInput }}
      >
        {/* hovering a part tells what it stands for */}
        {segments.map((segment, index) => (
          <Tooltip
            key={index}
            // wide parts would center the tooltip far from the mouse
            followCursor
            title={`${segment.label}: ${segment.value} (${Math.round(
              segment.width,
            )}%)`}
          >
            <Box
              sx={{
                width: `${segment.width}%`,
                backgroundColor: segment.color,
                transition: 'width 300ms',
              }}
            />
          </Tooltip>
        ))}
      </Box>

      <Typography
        fontSize="12px"
        className="monospace opacity-60 shrink-0 text-right w-[42px]"
      >
        {`${done}/${total}`}
      </Typography>
    </Box>
  );
};

export default WorkPackageProgressRow;
